var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import TabGroup from '~/components/tab-group/tab-group';
import ContentGroup from '~/components/content-group/content-group';
import { useIntl } from 'react-intl';
import VideoTab from './videos-tab/videos-tab';
import useDetailsContext from '../context';
import { GiveLink } from '../common/common';
import { useNavigate } from 'react-router-dom';
import $ from '~/helpers/$';
import JITLoad from '~/helpers/jit-load';
import { findSelectedTab, replaceSearchTerm } from '../common/tab-utils';
import './desktop-view.scss';
const importDetailsTab = () => import('./details-tab/import-details-tab');
const importInstructorTab = () => import('./instructor-resource-tab/import-instructor-resource-tab');
const importStudentTab = () => import('./student-resource-tab/import-student-resource-tab');
// eslint-disable-next-line complexity
function useLabelsFromModel(model, polish) {
    const intl = useIntl();
    const tabLabels = [
        polish
            ? 'Szczegóły książki'
            : intl.formatMessage({
                id: 'tabs.bookDetails'
            })
    ];
    if (!polish && model.freeStuffInstructor.content) {
        tabLabels.push(intl.formatMessage({
            id: 'tabs.instructorResources'
        }));
    }
    if (!polish && model.freeStuffStudent.content) {
        tabLabels.push(intl.formatMessage({
            id: 'tabs.studentResources'
        }));
    }
    if (model.videos.length) {
        tabLabels.push(intl.formatMessage({
            id: 'tabs.videos'
        }));
    }
    return tabLabels;
}
function useSelectedLabelTiedToSearchString(labels) {
    const navigate = useNavigate();
    const selectedTab = findSelectedTab(labels);
    const updateSelectedLabel = React.useCallback((newValue) => {
        const newSearchString = replaceSearchTerm(labels, newValue);
        navigate(newSearchString, { replace: true });
    }, [labels, navigate]);
    return [selectedTab, updateSelectedLabel];
}
function StubUntilSeen(_a) {
    var { active } = _a, JLParams = __rest(_a, ["active"]);
    const [seen, setSeen] = useState(false);
    useEffect(() => {
        if (active) {
            setSeen(true);
        }
    }, [active]);
    return seen ? React.createElement(JITLoad, Object.assign({}, JLParams)) : React.createElement("div", null);
}
export default function DesktopView() {
    const model = useDetailsContext();
    const polish = $.isPolish(model.title);
    const labels = useLabelsFromModel(model, polish);
    const [selectedLabel, setSelectedLabel] = useSelectedLabelTiedToSearchString(labels);
    const TabTag = 'h2';
    const activeIndex = labels.indexOf(selectedLabel);
    const isShowingCards = selectedLabel !== 'Book details';
    const setUseCardBackground = model.setUseCardBackground;
    useEffect(() => setUseCardBackground === null || setUseCardBackground === void 0 ? void 0 : setUseCardBackground(isShowingCards), [isShowingCards, setUseCardBackground]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tab-controller" },
            React.createElement(TabGroup, { TabTag, labels, selectedLabel, setSelectedLabel, "data-analytics-nav": "Book Details Tabs", listLabel: "Book Info Tabs" },
                React.createElement(GiveLink, null))),
        React.createElement("div", { className: "tab-content" },
            React.createElement(ContentGroup, { activeIndex: activeIndex, labels: labels },
                React.createElement(StubUntilSeen, { active: activeIndex === 0, importFn: importDetailsTab, polish: polish, model: model }),
                React.createElement(StubUntilSeen, { active: activeIndex === 1, importFn: importInstructorTab, model: model }),
                React.createElement(StubUntilSeen, { active: activeIndex === 2, importFn: importStudentTab }),
                model.videos[0] && React.createElement(VideoTab, { videos: model.videos[0] })))));
}
